import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { withDeferred } from '#shared/lib/hocs';

/** Чанк создаётся один раз на уровне модуля */
const AsyncProcessMonitorLazy = loadable(
    () => import(/* webpackChunkName: "AsyncProcessMonitor" */ './AsyncProcessMonitor')
);

/**
 * isInternalYandexUser-guard вынесен ВЫШЕ loadable: чтобы для внешних пользователей чанк не запрашивался вообще.
 * @kind helper
 */
function AsyncProcessMonitorLoadable() {
    const { isInternalYandexUser } = getSafeUserRequestContext();

    if (!isInternalYandexUser) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <AsyncProcessMonitorLazy />
        </Suspense>
    );
}

/**
 * withDeferred откладывает монтирование до requestIdleCallback
 * @kind helper
 */
export const AsyncProcessMonitorAsync = withDeferred(AsyncProcessMonitorLoadable);
